const GROUP_TABS = {
  POSTS: 'posts',
  MY_GROUPS: 'myGroups',
  ALL_GROUPS: 'allGroups',
} as const;

export type GroupTabKey = (typeof GROUP_TABS)[keyof typeof GROUP_TABS];

const GROUP_PRIVACY = {
  PUBLIC: 'Public',
  PRIVATE: 'Private',
} as const;

/** Who may publish in a group, mapped to the API's two boolean flags. */
const GROUP_POST_PERMISSION = {
  ALL_MEMBERS: 'allMembers',
  ALL_MEMBERS_WITH_APPROVAL: 'allMembersWithApproval',
  ADMINS_ONLY: 'adminsOnly',
} as const;

const GROUP_STATUS = {
  JOIN_NOW: 'join_now',
  PENDING: 'pending',
  JOINED: 'joined',
  OWNER: 'owner',
} as const;

export { GROUP_TABS, GROUP_PRIVACY, GROUP_POST_PERMISSION, GROUP_STATUS };
